import { ApolloClient } from '@apollo/client'
import { gql, TypedDocumentNode } from '@apollo/client'
import { BadRequestError, UnauthorizedError } from '../../errorTypes'
import { Customer } from '../types'

export interface GetCustomerFromOwnerHolderVariables {
  id: number
}

export const GET_CUSTOMER_FROM_OWNER_HOLDER_QUERY: TypedDocumentNode<{ getCustomerFromOwnerHolder: GetCustomerFromOwnerHolderResponse }, GetCustomerFromOwnerHolderVariables> = gql`
  query getCustomerFromOwnerHolder($id: Int!) {
    getCustomerFromOwnerHolder(id: $id) {
      __typename
      ... on GetCustomerSuccess {
        customer {
          ... on CompanyCustomer {
            id
            companyName
            businessId
            contactPerson
            contactPersonEmail
            phone
            address
            email
            identifier
            extraInfo
            co
            address
            zipcode
            city
            eInvoiceAddress
            eInvoiceOperator
            paymentTerms
            deliveryMethod
            additionalInfo
            notificationMethod
            source
          }

          ... on PersonCustomer {
            id
            ssn
            maskedSsn
            firstName
            lastName
            email
            phone
            address
            extraInfo
            address
            city
            identifier
            co
            zipcode
            eInvoiceAddress
            eInvoiceOperator
            paymentTerms
            deliveryMethod
            additionalInfo
            notificationMethod
            source
          }
        }
      }
      ... on UnauthorizedError {
        error {
          code
          message
          details
          context
        }
      }
    }
  }
`

export interface GetCustomerFromOwnerHolderSuccess {
  __typename: string
  customer: Customer
}

export type GetCustomerFromOwnerHolderResponse = GetCustomerFromOwnerHolderSuccess | BadRequestError | UnauthorizedError

export const getCustomerFromOwnerHolder = async (
  client: ApolloClient,
  ownerHolderId: number
): Promise<GetCustomerFromOwnerHolderResponse | undefined> => {
  try {
    const { data } = await client.query({
      query: GET_CUSTOMER_FROM_OWNER_HOLDER_QUERY,
      variables: { id: ownerHolderId },
      fetchPolicy: 'network-only',
    })

    if (!data) return undefined

    return data.getCustomerFromOwnerHolder
  } catch {
    return undefined
  }
}